<template>
  <div class="search-container">
    <!-- 搜索框 -->
    <div class="input-wrapper">
      <input v-model="searchValue" type="text" placeholder="请输入搜索关键词" />
      <span  class="clear-btn" v-if="searchValue" @click="clearInput">×</span>
    </div>
    <button class="sousuo" @click="triggerSearch">搜索</button>
    <button @click="goarticleList" class="gradient-btn at">网页教程</button>
    <router-link to="/ChatAi">
      <button class="gradient-btn xmai">小码AI</button>
    </router-link>
  </div>
</template>
  <script>
export default {
  name: "SearchInput",
  props: {
    debounceTime: {
      type: Number,
      default: 500, // 防抖时间默认500ms
    },
  },
  data() {
    return {
      searchValue: "", // 搜索关键词
      debounceTimer: null, // 防抖定时器
    };
  },
  watch: {
    searchValue: {
      handler(newValue) {
        if (newValue.trim() === "") {
          this.$emit("search-results", []); // 输入为空时发送空结果
          return;
        }

        // 防抖处理
        if (this.debounceTimer) clearTimeout(this.debounceTimer);
        this.debounceTimer = setTimeout(() => {
          this.triggerSearch();
        }, this.debounceTime);
      },
    },
  },
  methods: {
    triggerSearch() {
      this.$emit('update-data', 1); // 触发父组件事件
      this.$emit("search", this.searchValue.trim()); // 发送搜索关键词到父组件
    },
    clearInput() {
      this.searchValue = ""; // 清空输入框
      this.$emit("search", this.searchValue.trim()); // 发送搜索关键词到父组件
    },
    goarticleList() {
      this.$router.push("/article/article-List");
    },
  },
};
</script>
  
  <style scoped>
.input-wrapper {
  position: relative; /* 伪元素相对于父容器定位 */
  flex: 1;
  display: flex;
}

/* 伪元素右侧的 × 按钮 */
.clear-btn {
  position: absolute;
  top: 50%;
  right: 2vw;
  transform: translateY(-50%);
  cursor: pointer;
  color: #ffffff;
  background-color: #999;
  transition: color 0.3s ease;
  font-size: 3.4vw;
  border-radius: 50%;
  border: 1px solid #999;
  width: 4vw;
  height: 4vw;
  line-height: 4vw;
  text-align: center;
}

.clear-btn:hover {
  color: #f55654;
}

.search-container input::placeholder {
  font-size: 2.6vw; /* 字体大小使用vw */
}
.search-container {
  display: flex;
  margin: 2vw; /* 外边距使用vw */
  align-items: center;
}

.search-container input {
  padding: 1vw; /* 内边距使用vw */
  height: 5.3vw; /* 高度使用vw */
  font-size: 2.6vw; /* 字体大小使用vw */
  border-radius: 0.9vw 0 0 0.9vw; /* 边框圆角使用vw */
  border: 1px solid #f55654;
  outline: none;
  flex: 1;
  padding-right: 7vw;
}
.search-container input:focus {
  border-color: #f4a79b; /* 聚焦时的边框颜色 */
  box-shadow: 0 0 8px rgba(255, 87, 68, 0.6); /* 聚焦时的阴影效果 */
}
.search-container .sousuo {
  height: 7.7vw;
  padding: 0 3vw;
  font-size: 3vw; /* 字体大小使用vw */
  border: none;
  background: linear-gradient(
    125deg,
    #f54940,
    #f9832d
  ); /* 从亮红到深红的渐变 */
  color: white;
  letter-spacing: 10px;
  margin-right: 2vw;
  cursor: pointer;
  border-radius: 0 0.9vw 0.9vw 0; /* 边框圆角使用vw */
}
.gradient-btn {
  height: 7.7vw;
  font-size: 3vw; /* 字体大小使用vw */
  padding: 0 3vw;
  margin-right: 2vw;
  background-color: #f55654;
  border: none;
  color: white;
  background: linear-gradient(135deg, #f78d2b, #ff5733); /* 渐变背景 */
  cursor: pointer;
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15),
    inset 0 2px 4px rgba(255, 255, 255, 0.2); /* 外部+内部阴影 */
  transition: all 1.6s ease;
  border-radius: 0.9vw !important; /* 边框圆角使用vw */
  position: relative; /* 为光条的绝对定位提供参考 */
  overflow: hidden; /* 隐藏超出按钮外的部分 */
}

.gradient-btn.at::before {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 10%;
  height: 100%;
  background: rgba(255, 255, 255, 0.4); /* 白光的颜色 */
  transform: skewX(-20deg); /* 给光条一定的倾斜感 */
  transition: all 1.5s ease-in-out;
  box-shadow: 0 0 15px rgba(255, 255, 255, 0.6),
    0 0 30px rgba(255, 255, 255, 0.3); /* 羽化效果 */
  opacity: 0; /* 初始时光条不可见 */
}

.gradient-btn:active::before {
  opacity: 1;
  left: 100%; /* 光条从左侧到右侧横扫 */
}

/* 自动动画 */
@keyframes glow {
  0% {
    left: -100%;
    opacity: 0;
  }
  50% {
    left: 100%;
    opacity: 1;
  }
  100% {
    left: 100%;
    opacity: 0;
  }
}

.gradient-btn::before {
  animation: glow 3s infinite; /* 自动光条动画 */
}
.xmai {
  margin-right: 0;
  background: linear-gradient(135deg, #fd6833, #bd4ebd); /* 渐变背景 */
}
</style>
  